import { createSelector } from '@ngrx/store';
import { selectPaymentsAndStatementsState } from '../reducers';
import * as fromGenerateRefundStatement from '../reducers/generate-refund-statement.reducer';

export { GenerateRefundStatementState } from '../reducers/generate-refund-statement.reducer';

export const selectGenerateRefundStatementState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromGenerateRefundStatement.generateRefundStatementFeatureKey]
);

export const selectGenerateRefundStatementSuccess = createSelector(
  selectGenerateRefundStatementState,
  (state) => state?.success
);

export const selectGenerateRefundStatementFailure = createSelector(
  selectGenerateRefundStatementState,
  (state) => state?.failure
);

export const selectGenerateRefundStatementLoading = createSelector(
  selectGenerateRefundStatementState,
  (state) => state?.loading
);
